/* eslint-disable */
export default {
  parent: 'InheritFromParent',
  manual: 'ManualCpc',
  manualCpv: 'ManualCpv',
  manualCpm: 'ManualCpm',
  manualCpa: 'ManualCpa',
  enhancedCPC: 'EnhancedCpc',
  maximizeClicks: 'MaxClicks',
  maximizeConversions: 'MaxConversions',
  targetCpa: 'TargetCpa',
  targetRoas: 'TargetRoas',
  maxConversionValue: 'MaxConversionValue',
  targetImpressionShare: 'TargetImpressionShare',
  portfolioBidStrategy: 'PortfolioBidStrategy',
  costPerSale: 'CostPerSale',
  percentCpc: 'PercentCpc',
  commission: 'Commission',
  biddingStrategyTypeId: {
    InheritFromParent: 0,
    ManualCpc: 1,
    MaxClicks: 2,
    MaxConversions: 3,
    TargetCpa: 4,
    EnhancedCpc: 5,
    TargetRoas: 6,
    MaxConversionValue: 8,
    TargetImpressionShare: 9,
    ManualCpv: 11,
    ManualCpm: 12,
    PercentCpc: 13,
    Commission: 14,
    CostPerSale: 15,
    ManualCpa: 16
  },
  biddingStrategyType: {
    0: 'InheritFromParent',
    1: 'ManualCpc',
    2: 'MaxClicks',
    3: 'MaxConversions',
    4: 'TargetCpa',
    5: 'EnhancedCpc',
    6: 'TargetRoas',
    8: 'MaxConversionValue',
    9: 'TargetImpressionShare',
    11: 'ManualCpv',
    12: 'ManualCpm',
    13: 'PercentCpc',
    14: 'Commission',
    15: 'CostPerSale',
    16: 'ManualCpa'
  },
  biddingStrategyOption: {
    ManualCpc: 'BidStrategy_Manual',
    MaxClicks: 'BidStrategy_MaxClicks',
    MaxConversions: 'BidStrategy_MaxConversions',
    TargetCpa: 'BidStrategy_TargetCpa',
    EnhancedCpc: 'BidStrategy_EnhancedCPC',
    TargetRoas: 'BidStrategy_TargetRoas',
    MaxConversionValue: 'BidStrategy_MaxConversionValue',
    TargetImpressionShare: 'BidStrategy_TargetImpressionShare',
    PercentCpc: 'BidStrategy_PercentCpc',
    Commission: 'BidStrategy_Commission',
    ManualCpa: 'BidStrategy_ManualCpa'
  }
};

